export const SPEED_TYPE = {
  AVERAGE: 'Average',
  MAXIMUM: 'Maximum',
} as const

export type SpeedType = (typeof SPEED_TYPE)[keyof typeof SPEED_TYPE]

export const SPEED_TYPE_OPTIONS = [
  {
    label: 'Average Speed',
    value: SPEED_TYPE.AVERAGE,
  },
  {
    label: 'Maximum Speed',
    value: SPEED_TYPE.MAXIMUM,
  },
]
